import { useContext } from 'react';

import type { ILayoutInfo } from '@/context/GeniusLayout';
import { ContextGeniusLayout } from '@/context/GeniusLayout';

export default function useGeniusLayout(): ILayoutInfo {
  return useContext(ContextGeniusLayout);
}
